import { AutogenModelDrsPayeeMulticompany, AutogenRowDrsPayeeMulticompany } from "./autogen/AutogenModelDrsPayeeMulticompany";

export class ModelDrsPayeeMulticompany extends AutogenModelDrsPayeeMulticompany<RowDrsPayeeMulticompany> {
	constructor() {
		super(RowDrsPayeeMulticompany);
	}
}

export class RowDrsPayeeMulticompany extends AutogenRowDrsPayeeMulticompany {
}